import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {getPromotionCodeInfo} from '@/lib/payment/paymentService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export default function useCoupon(coupon: string, enabled = true) {
  const account = useAccountInformationValue()

  return useQuery({
    queryKey: ['!promotionCodeInfo', account?.id, coupon],
    queryFn: !!coupon && enabled ? async () => getPromotionCodeInfo(coupon) : skipToken,
    ...NO_REFETCH_OPTIONS,
  })
}
